import cn from "classnames";
import s from "./Tabs.module.scss";

const Tab = ({
  icon,
  text,
  counter,
  isActive = false,
  tabIndex,
  className,
  onChange = () => { },
  changeActiveTab,
  disabled,
  ...props
}) => {
  const classNames = cn(s.tab, isActive && s.active, className);
  return (
    <div
      {...props}
      disabled={disabled}
      className={classNames}
      onClick={
        disabled
          ? () => { }
          : () => {
            changeActiveTab(tabIndex);
            onChange();
          }
      }
    >
      <div className={s.tabText}>
        {icon && <img src={`/static/images/svg/${icon}`} alt="" />}
        {text}
      </div>
    </div>
  );
};

export default Tab;
